import { render, staticRenderFns } from "./SearchFormulas.vue?vue&type=template&id=0a21b725&"
import script from "./SearchFormulas.vue?vue&type=script&lang=js&"
export * from "./SearchFormulas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports